import {
  styled,
  Span as CustomSpan,
  Link as CustomLink,
  Label as CustomLabel,
  Flex
} from '@fareye/ui'
import {
  IoIosAirplane,
  MdDirectionsBoat,
  MdLocalShipping,
  MdTrain
} from '@fareye/utils'

export const style = {
  iconSize: 20,
  endIconSize: 26,
  iconStyle: {
    border: '1px solid #727272',
    borderRadius: '50%',
    background: '#fff',
    zIndex: 5
  }
}

export const TimeLine: any = styled.div`
  display: flex;
  background: #fff;
  padding: ${(props: any) => props.padding ?? '10px 5px'};
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid ${(props: any) => props.theme.colors.gray4};
`

export const EndStage: any = styled(Flex)`
  position: relative;
  flex-direction: column;
  @media (max-width: 1920px) {
    width: 160px;
    min-width: 160px;
  }
  @media (max-width: 1440px) {
    width: 160px;
    min-width: 160px;
  }
  @media (min-width: 1921px) {
    width: 180px;
    min-width: 180px;
  }
  .popover {
    display: none;
  }
  &:hover {
    .popover {
      display: block;
    }
  }
`

export const Label = styled(CustomLabel)`
  text-transform: capitalize;
  @media (max-width: 1920px) {
    font-size: 12px;
  }
  @media (max-width: 1440px) {
    font-size: 10px;
  }
  @media (min-width: 1921px) {
    font-size: 14px;
  }
`
export const Span: any = styled(CustomSpan)`
  text-transform: capitalize;
  width: auto;
  @media (max-width: 1920px) {
    font-size: 12px;
  }
  @media (max-width: 1440px) {
    font-size: 10px;
  }
  @media (min-width: 1921px) {
    font-size: 14px;
  }
`
export const Link = styled(CustomLink)`
  color: ${(props: any) => props.theme.colors.primary};
  text-transform: capitalize;
  @media (max-width: 1920px) {
    font-size: 12px;
  }
  @media (max-width: 1440px) {
    font-size: 10px;
  }
  @media (min-width: 1921px) {
    font-size: 14px;
  }
`
export const BoldText = (styled as any)(Label)`
  color: #212121;
`
export const LandmarkText = styled(BoldText)`
  display: block;
  display: -webkit-box;
  max-width: 400px;
  margin: 0 auto;
  margin-left: 0;
  margin-right: 20px;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${(props: any) => props.linesToShow || 2};
  line-height: 22px;
  overflow: 'hidden';
  text-overflow: ellipsis;
  font-weight: normal;
  white-space: pre-wrap;
  @media (max-width: 1920px) {
    font-size: 14px;
    height: ${(props: any) => 1.5 * 14 * (props.linesToShow || 2)}px;
  }
  @media (max-width: 1440px) {
    font-size: 14px;
    height: ${(props: any) => 1.5 * 14 * (props.linesToShow || 2)}px;
  }
  @media (min-width: 1921px) {
    font-size: 14px;
    height: ${(props: any) => 1.5 * 16 * (props.linesToShow || 2)}px;
  }
`
const vehicleStyle = `
  background: #fff;
  top: -25px;
  z-index: 1;
`
// TODO: z-index above can be removed
// if icon COMPONENT is used after line COMPONENT in stages COMPONENT
// it will help in mobi - TRN icon z-index conflicts

export const Ship: any = styled(MdDirectionsBoat)`
  color: ${(props: any) => props.theme.colors.blue6};
  left: ${(props: any) => props.leftMargin}%;
  ${vehicleStyle}
`
export const Truck: any = styled(MdLocalShipping)`
  color: ${(props: any) => props.theme.colors.blue6};
  left: ${(props: any) => props.leftMargin}%;
  ${vehicleStyle}
`
export const Plane: any = styled(IoIosAirplane)`
  color: ${(props: any) => props.theme.colors.blue6};
  left: ${(props: any) => props.leftMargin}%;
  ${vehicleStyle}
`
export const Rail: any = styled(MdTrain)`
  color: ${(props: any) => props.theme.colors.blue6};
  left: ${(props: any) => props.leftMargin}%;
  ${vehicleStyle}
`
export const PercentagePopOver: any = styled.div`
  background: #fff;
  top: -20px;
  z-index: 1;
  position: absolute;
  padding: 0px;
  left: ${(props: any) => props.leftMargin}%;
`
